import React, { ReactElement } from 'react';
import { Skeleton } from 'primereact/skeleton';

// Placeholder row shown in LocationsList while the first page of locations/metrics is still
// loading (before that, the list is simply empty — nothing to show a row for yet), and under
// the list while each further page loads. Mirrors
// LocationSummaryTile's column layout 1:1 (same class names) so it reserves the exact same
// footprint and the real tiles don't jump into place once data arrives.
const LocationSummaryTileSkeleton = (): ReactElement => (
    <div className='location-summary-tile location-summary-tile--skeleton' data-testid='location-summary-tile-skeleton' aria-hidden='true'>
        <div className='lst-name-col'>
            <div className='lst-name-text'>
                <Skeleton width='70%' height='0.9rem' className='mb-2' />
                <Skeleton width='45%' height='0.7rem' />
            </div>
        </div>

        <Skeleton shape='rectangle' width='58px' height='44px' borderRadius='6px' />
        <Skeleton shape='rectangle' width='58px' height='44px' borderRadius='6px' />

        <div className='lst-graph-col'>
            <Skeleton width='100%' height='22px' borderRadius='3px' />
        </div>

        <div className='lst-metrics-wrap'>
            <div className='lst-metrics'>
                <div className='lst-metrics-left'>
                    <Skeleton width='120px' height='0.8rem' />
                    <Skeleton width='110px' height='0.8rem' />
                    <Skeleton width='90px' height='0.8rem' />
                </div>
                <div className='lst-metrics-right'>
                    <Skeleton width='130px' height='0.8rem' />
                    <Skeleton width='100px' height='0.8rem' />
                    <Skeleton width='100px' height='0.8rem' />
                </div>
            </div>
        </div>
    </div>
);

export default LocationSummaryTileSkeleton;
